import React from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

interface SettingButtonProps {
    drawerOpener: React.Dispatch<React.SetStateAction<boolean>>;
    setSettingCmcId: React.Dispatch<React.SetStateAction<string>>;
    setNewSettingFlag?: React.Dispatch<React.SetStateAction<boolean>>;
    cmcId: string;
    title: string;
}

const SettingButton = (props: SettingButtonProps) => (
    <Box
        onClick={() => {
            // ドロワーを開く
            if (props.drawerOpener) {
                props.drawerOpener(true);
            }

            // 新規で目標設定する場合はフラグをtrueにする
            if (props.setNewSettingFlag) {
                props.setNewSettingFlag(true);
            }

            props.setSettingCmcId(props.cmcId);
        }}
    >
        <Typography
            variant="h6"
            sx={{
                fontWeight: "bold",
                textDecoration: "underline",
                transition: "all 0.2s ease-in-out",
                color: "#888",
                "&:hover": {
                    opacity: 0.7,
                    cursor: "pointer",
                },
            }}
        >
            {props.title}
        </Typography>
    </Box>
);

export default SettingButton;
